<template>
    <div class="shop__unloadingpoints">
        <div class="shop__unloadingpoint" v-for="(pos, index) in TransactionPositions" :key="pos.id">
            <div class="shop__unloadingpoint-warenempfaenger">
                <ZipcodeOrWarenempfaenger :PositionId="pos.id" :ShowPosIndex="NumPositions > 1" :PositionIndex="index + 1" />
            </div>
            <div class="shop__unloadingpoint-amount">
                <InputWithLabel :label="Strings['Shop.LabelAmount']" type="number" :value="pos.amount" @change="newAmount => updateAmount(newAmount, pos.id)" :postfix="AmountUnits" :rules="AmountRules" :validationmode="upInputValidation" />                
            </div>
            <div class="shop__removeunloadingpoint">
                <label class="migrol-form__input-label migrol-form__input-label--invisible">delete</label>
                <button class="shop__removeunloadingpoint-button" v-if="index > 0" @click="removePosition(pos.id)">
                    <img :src="Images['deleteIcon']" style="width:18px;height:auto;display:inline-block" />
                </button>
            </div>
            <div class="shop__unloadingpoint-presets" v-if="Presets">
                <button v-for="presetValue in Presets" :key="presetValue" @click="updateAmount(presetValue, pos.id)">{{presetValue}} {{AmountUnits}}</button>
            </div>
        </div>        
        <div class="shop__addunloadingpoint">
            <button v-if="ShowAddButton" @click="addPosition" class="shop__addunloadingpoint-button"><span class="shop__addunloadingpoint-icon"><i class="fas fa-plus"></i></span> {{Strings['Shop.ButtonAddUnloadingPoint']}}</button>
            <div v-if="ShowMoreUPFormText" class="shop__more-unloadingpoints">
                <v-runtime-template :template="MoreUPFormText" />
            </div>
        </div>
    </div>
</template>

<script>
    import ZipcodeOrWarenempfaenger from './ZipcodeOrWarenempfaenger';
    import { mapState } from 'vuex';
    import Position from '@/models/Position';
    import Transaction from '@/models/Transaction';
    import VRuntimeTemplate from 'v-runtime-template';

    export default {
        props: {
            AmountUnits: {
                type: String,
                required: true
            },
            MaxNumPositions: {
                type: Number,
                default: 1
            },
            Presets: {
                type: Array,
                default: null
            }
        },
        computed: {
            ...mapState([
                'MinAmountPerUP',
                'MaxAmountTotal',
                'MoreUPFormUrl',
                'Strings',
                'Images'
            ]),
            TransactionPositions() {
                return Position.query().orderBy('id', 'asc').get();
            },
            CurrentTransaction() {
                return Transaction.query().first();
            },
            ShowAddButton() {
                return this.TransactionPositions.length < this.MaxNumPositions && !this.CurrentTransaction.isCampaignOffer;
            },
            AmountRules() {
                if (this.CurrentTransaction.isCampaignOffer) {
                    return 'required|integer|min_value:' + this.MinAmountPerUP + '|max_value:' + this.MaxAmountTotal;
                } else {
                    return 'required|integer|min_value:' + this.MinAmountPerUP;
                }
            },
            NumPositions() {
                return this.TransactionPositions.length;
            },
            ShowMoreUPFormText() {
                return (
                    !this.CurrentTransaction.isCampaignOffer
                    && this.TransactionPositions.length == this.MaxNumPositions //only show when max amount of positions is reached
                    && this.MoreUPFormUrl != null
                    && this.MoreUPFormUrl != ''
                );
            },
            MoreUPFormText() {
                return '<span>' + this.Strings['Shop.InfoMoreUnloadingsPointBnT'] + '</span>';
            }
        },
        methods: {
            addPosition() {
                //insert a new blank position
                Position.insert({
                    data: {
                        transaction_id: Transaction.query().first().id
                    }
                });
            },
            removePosition(id) {
                Position.delete(id);
            },
            updateAmount(newAmount, positionId) {
                let num = Number(newAmount);
                if (!isNaN(num)) {
                    Position.update({
                        id: positionId,
                        amount: num
                    });
                }
            },
            upInputValidation(context) {
                if (context.value === undefined || context.value === null) {
                    return { on: [] };
                }

                return { on: ['input', 'blur', 'change'] };
            }
        },
        components: {
            ZipcodeOrWarenempfaenger,
            VRuntimeTemplate
        }
    };
</script>